export default angular.module("UserService", []).factory("Users", [
  "$http",
  "Flash",
  function ($http, Flash) {
    function saveNewUser(newUser, callback) {
      $http.post("/api/users/", newUser).then(
        (res) => {
          const message = `New user created with ID: ${res.data.ID}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Saving new user failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateUser(newData, callback) {
      $http.put(`/api/users/${newData.ID}`, newData).then(
        (res) => {
          const message = `Update successful for user ID: ${res.data.ID}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating user failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteUser(userData, callback) {
      $http.delete(`/api/users/${userData.ID}`).then(
        (res) => {
          const message = `Deletion successful for user ID: ${userData.ID}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Deleting user failed with error code: ${userData.ID}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    return {
      saveNewUser,
      updateUser,
      deleteUser,
    };
  },
]);
